import { atom, selector } from 'recoil'

import { isValidEmail } from 'Helpers/validators'

import type { ModalEngagementUpsellingState } from 'Pages/RecipientsOverview/types'

export const modalEngagementUpsellingState =
  atom<ModalEngagementUpsellingState>({
    key: 'recipientsList_modalEngagementUpsellingState',
    default: {
      show: false,
      email: '',
      isDirty: false,
    },
  })

export const modalEngagementUpsellingCanConfirmState = selector<boolean>({
  key: 'recipientsList_modalEngagementUpsellingCanConfirmState',
  get: ({ get }) => {
    const { email } = get(modalEngagementUpsellingState)

    return isValidEmail(email)
  },
})
